module.exports = __webpack_public_path__ + "media/images/filmapp_old-dd1692a9.jpg";